import { render, staticRenderFns } from "./AbaDestaques.vue?vue&type=template&id=067f9c73&scoped=true&"
import script from "./AbaDestaques.vue?vue&type=script&lang=js&"
export * from "./AbaDestaques.vue?vue&type=script&lang=js&"
import style0 from "./AbaDestaques.vue?vue&type=style&index=0&id=067f9c73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067f9c73",
  null
  
)

export default component.exports